import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import ScreenHeader from "../ScreenHeader";
import PasswordControl from "../PasswordControl";
import PropTypes from "prop-types";
import { isValidPassword } from "../../util/validity-helpers";
import { TriyoForm } from "../TriyoForm";
import "./AccountSetup.scss";

import { connect } from 'react-redux';
import { createStructuredSelector } from "reselect";

const AccountSetup = ({ validate, onValidate, orgId, orgName }) => {
    const [fullName, setFullName] = useState("");
    const [organization, setOrganization] = useState(orgName);
    const [isCustomOrganization, setIsCustomOrganization] = useState(!!orgId);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const onFullNameChange = (e) => {
        const { value } = e.target;
        setFullName(value);
        if (!isCustomOrganization) {
            setOrganization(
                (value) ? `${value}'s Organization` : ""
            );
        }
    }

    const onOrganizationChange = (e) => {
        setIsCustomOrganization(true);
        setOrganization(e.target.value);
    };

    const validator = () => {
        if (!(fullName) ||
            !(organization) ||
            !isValidPassword(password) ||
            password !== confirmPassword) {
            return onValidate({
                isValid: false,
                fields: {},
            })
        }
        return onValidate({
            isValid: true,
            fields: {
                fullName,
                organization: orgId ? orgName : organization,
                password,
            },
        });
    };

    useEffect(() => {
        validator();
    });

    return (
        <Container className="account-setup">
            <Row>
                <Col>
                    <ScreenHeader
                        heading="Hi there, let's setup your account"
                        subHeading="Tell us about you"
                    />
                </Col>
            </Row>
            <TriyoForm>
                <Form noValidate validated={validate} autoComplete="off">
                    <Row>
                        <Col xs="5">
                            <Form.Group>
                                <Form.Label>Full name</Form.Label>
                                <Form.Control
                                    className="name-input input"
                                    type="text"
                                    value={fullName}
                                    onChange={onFullNameChange}
                                    required
                                    autoComplete="off"
                                    />
                                <Form.Control.Feedback type="invalid">
                                    Please provide a full name.
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col xs="5">
                            <Form.Group>
                                <Form.Label>Organization</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={orgId ? orgName : organization}
                                    onChange={onOrganizationChange}
                                    disabled={orgId}
                                    required
                                    autoComplete="off"
                                    />
                                <Form.Control.Feedback type="invalid">
                                    Please provide the organization name.
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="5">
                            <Form.Group>
                                <Form.Label>Password</Form.Label>
                                    <PasswordControl className="password-input input"
                                        onChange={setPassword}
                                        value={password}
                                        isInvalid={validate && !isValidPassword(password)}
                                    />
                            </Form.Group>
                        </Col>
                        <Col xs="5">
                            <Form.Group>
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control
                                    onChange={(e) => { setConfirmPassword(e.target.value); }}
                                    value={confirmPassword}
                                    autoComplete="off"
                                    type="password"
                                    required
                                    isInvalid={validate && password !== confirmPassword }
                                >
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">
                                { !confirmPassword ? "Please confirm your password." : "The passwords you entered do not match." }
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </TriyoForm>
        </Container>
    );
}

AccountSetup.propTypes = {
    validate: PropTypes.bool.isRequired,
    onValidate: PropTypes.func.isRequired,
    orgId: PropTypes.number,
    orgName: PropTypes.string,
}

const mapState = createStructuredSelector ({
    orgId: state => state.auth.orgId,
    orgName: state => state.auth.orgName,
})

export default connect(mapState, null)(AccountSetup);
